module.exports = __webpack_public_path__ + "img/7percent.5c96d6e5.svg";